export default "__VITE_ASSET__41613475__"